module.exports = __webpack_public_path__ + "static/media/5.d4799755.jpg";